import React, { useState, useEffect } from "react";
import axiosInstance from "../../services/auth";
import "./Logistics.css";
import { toast } from "react-toastify";

const LogisticsEmployeeForm = ({
  selectedCompany,
  companyId,
  employee,
  onClose,
}) => {
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState([]);

  const [formData, setFormData] = useState(
    employee
      ? {
          ...employee,
          companyId: employee.companyId?._id || employee.companyId || companyId || "",
          location: employee.location || "",
        }
      : {
          companyId: companyId || "",
          name: "",
          employeeNo: "",
          status: true,
          location: "",
        }
  );

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        // Show every company in the system, not only the ones assigned to the
        // logged-in role. "/company" is superadmin-only, so use "/company/all",
        // which is allowed for admin, superadmin and user.
        const response = await axiosInstance.get("/company/all");
        const companyList =
          response.data.data || response.data.companies || [];
        setCompanies(companyList);
        if (!formData.companyId && companyList.length > 0) {
          setFormData((prev) => ({
            ...prev,
            companyId: companyId || companyList[0]._id,
          }));
        }
      } catch (error) {
        toast.error("Error fetching companies");
      }
    };

    fetchCompanies();
  }, [companyId, formData.companyId]);

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("modal")) {
      onClose();
    }
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.companyId) {
      toast.error("Please select a company");
      return;
    }

    setLoading(true);

    try {
      if (employee) {
        const response = await axiosInstance.patch(
          `/logistics/employee/${employee._id}`,
          formData
        );
        if (response.data.statusCode === 400) {
          throw { response: { data: { message: response.data.message[0] } } };
        }
      } else {
        const response = await axiosInstance.post("/logistics/employee", formData);
        if (response.data.statusCode === 400) {
          throw { response: { data: { message: response.data.message[0] } } };
        }
      }

      onClose();
      toast.success(
        employee
          ? "Logistics Employee updated successfully"
          : "Logistics Employee created successfully"
      );
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Error saving logistics employee"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      onClick={handleOutsideClick}
      style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
      >
        <div className="modal-content employee_model">
          <div className="modal-header text-white text-center vesel_form">
            <h5 className="modal-title">
              {employee ? "Edit Logistics Employee" : "Add Logistics Employee"}
            </h5>
            <button
              type="button"
              className="btn-close text-white"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body vesel_form">
            <form onSubmit={handleSubmit}>
              <div className="card shadow-sm mb-4 rounded-3">
                <div className="card-body">
                  <h5 className="card-title text-center mb-4">
                    Employee Details
                  </h5>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Employee Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label">Employee No</label>
                      <input
                        type="text"
                        className="form-control"
                        name="employeeNo"
                        value={formData.employeeNo}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label">Company Name</label>
                      <select
                        className="form-select"
                        name="companyId"
                        value={formData.companyId}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Company</option>
                        {companies.map((comp) => (
                          <option key={comp._id} value={comp._id}>
                            {comp.company_name} ({comp.company_code})
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label">Status</label>
                      <select
                        className="form-select"
                        name="status"
                        value={formData.status ? "true" : "false"}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            status: e.target.value === "true",
                          }))
                        }
                        required
                      >
                        <option value="true">Active</option>
                        <option value="false">Inactive</option>
                      </select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label">Location</label>
                      <select
                        className="form-select"
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Location</option>
                        <option value="Seatrium (TY)">Seatrium (TY)</option>
                        <option value="Seatrium (TBY)">Seatrium (TBY)</option>
                        <option value="Pandan Workshop">Pandan Workshop</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-4 text-center">
                <button type="submit" className="button-2" disabled={loading}>
                  {loading
                    ? employee
                      ? "Updating..."
                      : "Creating..."
                    : employee
                    ? "Update Employee"
                    : "Add Employee"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogisticsEmployeeForm;
